import { useRef } from "react";
import { useJobStore } from "@/dentlab/src/store/Jobs";
import { JobDocumentTypeEnum } from "../job-document/job-document.types";
import { TemplateSelectDialog } from "./template-select-dialog.component";
import { RoundToType } from "@/dentlab/src/store/Jobs/utils";

export const CreateJobDocumentFromTemplateDialog: React.FC<{
	open: boolean;
	setOpen: (open: boolean) => void;
	templateType: JobDocumentTypeEnum;
	onDocumentCreated?: (documentId: number) => void;
}> = ({ open, setOpen, templateType, onDocumentCreated }) => {
	const { createJobDocumentFromTemplate, isCreateJobDocumentAllowed, job } =
		useJobStore((state) => ({
			createJobDocumentFromTemplate: state.createJobDocumentFromTemplate,
			isCreateJobDocumentAllowed: state.isCreateJobDocumentAllowed,
			job: state.job,
		}));

	const isCreatingDocumentRef = useRef(false);

	const handleSelectTemplate = async (templateId: number) => {
		if (!open || isCreatingDocumentRef.current) return;
		isCreatingDocumentRef.current = true;
		try {
			const documentId = await createJobDocumentFromTemplate(
				templateId,
				templateType
			);
			setOpen(false);
			if (documentId && onDocumentCreated) {
				onDocumentCreated(documentId);
			}
		} finally {
			isCreatingDocumentRef.current = false;
		}
	};

	return (
		<TemplateSelectDialog
			open={open}
			setOpen={setOpen}
			onSelect={handleSelectTemplate}
			disabled={!isCreateJobDocumentAllowed(templateType).isAllowed}
			priceListId={job?.price_list_id ?? null}
			tpValue={job?.tp_value ?? 1}
			taxRate={job?.tax_rate ?? 8.1}
			roundTo={(job?.round_to as RoundToType) ?? RoundToType.TO_RAPPEN}
		/>
	);
};
